export default __webpack_public_path__ + "static/media/bi.c6a1308d.svg";